
import React from 'react';
import PropTypes from 'prop-types';
import { BaseButton, SecondaryButton } from '@nextgen/frontend-components-atoms';
import * as S from './CookieBanner.styles';

const CookieBanner = ({
  buttonText,
  rejectButtonText,
  isAuth,
  linkText,
  setShowCookieBanner,
  text,
  title
}) => {

  const handleCookieConsent = hasConsent => {
    window?.localStorage?.setItem?.('cookieConsent', JSON.stringify({
      hasAskedCookieConsent: true,
      hasConsent
    }));

    if (hasConsent) {
      window.gtag('consent', 'update', {
        ad_storage: 'denied',
        analytics_storage: 'granted'
      });
    } else {
      window.gtag('consent', 'update', {
        ad_storage: 'denied',
        analytics_storage: 'denied'
      });
    }

    setShowCookieBanner(false);
  }

  return (
    <S.CookieBanner>
      <div>
        <S.Title>{title}</S.Title>
        <S.Text>{text}</S.Text>
      </div>
      <S.Actions>
        <BaseButton className="cookie-btn" onClick={() => handleCookieConsent(true)}>{buttonText}</BaseButton>
        <SecondaryButton className="cookie-btn reject-btn" onClick={() => handleCookieConsent(false)}>{rejectButtonText}</SecondaryButton>
        <S.Link href={isAuth ? '/auth/manage-cookie' : '/content/manage-cookie'}>
          {linkText}
        </S.Link>
      </S.Actions>
    </S.CookieBanner>
  )
}

CookieBanner.defaultProps = {
  buttonText: 'Agree',
  rejectButtonText: 'Reject all',
  isAuth: false,
  linkText: 'Manage cookie preferences',
  text: "We use cookies to collect and analyse information on our site's performance and to enable the site to function. You can choose to allow all cookies by clicking ‘Allow all’ or manage them individually by clicking ‘Manage cookie preferences,’ where you will also find more information.",
  title: 'Site traffic Information and Cookies'
};

CookieBanner.propTypes = {
  buttonText: PropTypes.string,
  rejectButtonText: PropTypes.string,
  isAuth: PropTypes.bool,
  linkText: PropTypes.string,
  setShowCookieBanner: PropTypes.func.isRequired,
  text: PropTypes.string,
  title: PropTypes.string
};

export default CookieBanner;